<script setup lang="ts">
import { useCookieConsentDialogState } from '@/shared/lib';

import { CookieConsentBannerTemplate } from './templates';

const { acceptNotRequired, isDialogVisible, rejectNotRequired } = useCookieConsentDialogState();
</script>

<template>
  <Transition
    enter-active-class="transition-[opacity] duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-[opacity] duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <CookieConsentBannerTemplate
      v-if="isDialogVisible"
      @accept="acceptNotRequired"
      @reject="rejectNotRequired"
    />
  </Transition>
</template>
